import type { RenderExpandIconProps } from 'rc-table/lib/interface'

import { CaretDownOutlined } from '@ant-design/icons'
import cx from 'classnames'

export function ExpandIcon(props: RenderExpandIconProps<unknown>): JSX.Element | null {
  if (!props.expandable) {
    return null
  }

  return (
    <button
      type='button'
      className='flex items-center justify-center p-1 ml-2'
      onClick={event => {
        props.onExpand(props.record, event)
      }}
    >
      <CaretDownOutlined className={cx('text-gray-300 text-xs', props.expanded && 'rotate-180')} />
    </button>
  )
}
